/* eslint-disable no-alert */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Auth } from 'aws-amplify';
import { Button, Label, TextInput, Spacer, Tile, Logo } from '../../../components';

const ResendVerify = () => {
  const navigate = useNavigate();

  const [hasSendCode, setHasSendCode] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const { t } = useTranslation();
  const [error, setError] = useState(false);
  const [state, setState] = React.useState({
    username: '',
    code: '',
    password: '',
    confirmPassword: '',
    status: '',
  });

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };


  const sendCode = async (username: string) => {
    try {
      setIsSending(true);
      setError(false);
      setHasSendCode(false);

      await Auth.resendSignUp(username.toLowerCase());
      setHasSendCode(true);
    } catch (err) {
      setError(true);
      // setError(err.message);
    } finally {
      setIsSending(false);
    }
  };

  const onSubmit = async (values: { username: any; password: any; confirmPassword: any; code: any; }) => {
    const { username, code } = values;

    try {
      setIsUpdating(true);
      setError(false);

      await Auth.confirmSignUp(username.toLowerCase(), code);
      navigate('/login');
    } catch (err) {
      setError(true);
      // setError(err.message);
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div className="hsg-login">
      <Logo size='350px' />
      <Spacer value={20} />

      {hasSendCode ?
        <div className='hsg-login__form-wrapper'>
          <Label center size='h6'>
            Get new account verification code
          </Label>
          <Spacer value={20} />
          <TextInput
            id="username"
            type="email"
            value={state.username}
            autocomplete="off"
            // autocomplete="current-password"
            placeholder={t('email') || 'Email'}
            label={t('email') || 'Email'}
            onChange={onChange}
          />
          <Spacer value={10} />
          <TextInput
            id="code"
            value={state.code}
            placeholder={t('code') || 'Code'}
            label={t('code') || 'Code'}
            onChange={onChange}
          />
          <Spacer value={10} />
          <div className="super-centered auth__btn-wrapper">
            <Button loading={state.status === 'loading'} size="large" className="auth__btn-styles" onClick={() => onSubmit(state)} >
              {t('Submit')}
            </Button>
          </div>

        </div>
        :
        <div className='hsg-login__form-wrapper'>
          <Label center size='h6'>
            Get new account verification code
          </Label>
          <Spacer value={20} />
          <TextInput
            id="username"
            type="Email"
            autocomplete="Email"
            value={state.username}
            placeholder={t('email') || 'Email'}
            label={t('email') || 'Email'}
            onChange={onChange}
          />

          <Spacer value={10} />

          <div className="super-centered auth__btn-wrapper">
            <Button loading={state.status === 'loading'} size="large" className="auth__btn-styles" onClick={() => sendCode(state.username)} >
              {t('Get Code')}
            </Button>
          </div>

        </div>
      }

      <Spacer value={10} />
      {error && <Label color='danger'>
        {t('Error. Please contact your administrator.')}
      </Label>}
    </div>
  );
};
export default ResendVerify;
